import type { ThreadEntry } from "../../../api/threads/liveMessages";
import { reviewedChangeSetOf, reviewedInputOf } from "./humanStepResponse";

/**
 * By change set: the entry of the last person step that reviews it among a Run's entries. The review draws the change
 * set, so a step that made or changed it before shows one line linking there (usability round 6: drawn once).
 */
export function changeSetReviews(entries: readonly ThreadEntry[]): ReadonlyMap<string, number> {
  const reviews = new Map<string, number>();
  for (const entry of entries) {
    if (entry.payload.kind !== "human_step_requested") continue;
    // A curator's change set review (`review_change_set`, the library's "Review the change"), or a review of a step's
    // output that is a change set (Sol r1 S1).
    const reviewed = reviewedInputOf(entry.payload)?.value;
    const changeSet = reviewedChangeSetOf(entry.payload) ?? (reviewed?.output_kind === "change_set" ? reviewed.change_set_id : null);
    if (changeSet !== null) reviews.set(changeSet, entry.number);
  }
  return reviews;
}
